import routes from './routes';
import type { RouteRecordRaw } from 'vue-router';
import { buildRootURL } from '@centric-os/helpers';
import { AP3UserManagementRouteNames, AP3UserManagementRoutePathNames } from './enums';
import { useAuthStore } from '@centric-os/stores/auth/use-auth-store';
import { SitesRouteNames } from '@/views/app-modules/sites';
import { P2Role } from '@centric-os/types';

const App = () => import('./App.vue');

export * from './enums';

export const route: RouteRecordRaw = {
  path: buildRootURL(AP3UserManagementRoutePathNames.AP3_USERS),
  name: AP3UserManagementRouteNames.AP3_USERS_ROOT,
  meta: {
    requireAuth: true,
  },
  component: App,
  children: routes,
  beforeEnter: () => {
    const authStore = useAuthStore();

    if (authStore.hasRole(P2Role.ADMIN)) {
      return true;
    }

    // Change to HOME when we have dashboard
    return { name: SitesRouteNames.SITES_LIST };
  },
};
